import { createSelector } from 'reselect';
import { getProjectListData } from 'src/modules/project-list/selectors/getProjectListData';

export const getProjectListProjects = createSelector([
  getProjectListData,
], (data) => data.projects);
